import React from 'react';
import './about.css'
const About = () => {
    return (
        <div className='mx-3 mt-8 lg:mt-20 lg:mx-40' id='about'>
            <h1 className='mb-4 text-3xl font-semibold text-center lg:mb-10'>About me</h1>
            <div className='grid grid-cols-1 gap-5 lg:gap-14 lg:grid-cols-2'>
                <div className='about lg:fonts'>
                    <p className='mb-4'>
                        I'm Maruf.I'm a junior Mern stact web developer.Also I'm student and just complete my HSC exam.I love coding and my dream is to be a good programmer.My coding journey was started about two years ago.
                    </p>
                    <p className='mb-4'>
                        I completed my HSC exam from science background.Now I want to read in CSE(computer science engeniering).
                    </p>
                    <p>
                        I'm a sport lover.I love cricket.In my leisure I go out for refreshment.I love coding at late night.I do word hard and I hope one day I will be success.
                    </p>
                </div>
                <div className=''>
                    <div className='text-center'>
                        <p className='text-xl font-semibold'>Skills</p>
                        <hr className='w-48 mx-auto hr' />
                    </div>
                    <div className='mt-3 text-start lg:text-center'>
                        <div className=''>
                            <p className='skill'>HTML5</p><progress className="w-56 progress progress-info" value="95" max="100"></progress>
                        </div>

                        <p className='skill'>CSS3</p><progress className="w-56 progress progress-info" value="92" max="100"></progress>


                        <p className='skill'>Bootstrap</p><progress className="w-56 progress progress-info" value="90" max="100"></progress>


                        <p className='skill'>Tailwind css</p><progress className="w-56 progress progress-info" value="82" max="100"></progress>


                        <p className='skill'>Javascipt</p><progress className="w-56 progress progress-info" value="80" max="100"></progress>


                        <p className='skill'>React JS</p><progress className="w-56 progress progress-info" value="85" max="100"></progress>


                        <p className='skill'>Express JS</p> <progress className="w-56 progress progress-info" value="50" max="100"></progress>


                        <p className='skill'>Mongodb</p><progress className="w-56 progress progress-info" value="65" max="100"></progress>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;